const motionUnderlines = document.querySelectorAll('[data-motion-underline]');

if (motionUnderlines.length) {
  const showUnderline = (element) => element.classList.add('is-motion-visible');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion || !('IntersectionObserver' in window)) {
    motionUnderlines.forEach(showUnderline);
  } else {
    const underlineObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        showUnderline(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.2,
    });

    motionUnderlines.forEach((element) => underlineObserver.observe(element));
  }
}
